import { Platform } from 'react-native';
export const PlatformUtils = {
    isWeb: () => {
        return Platform.OS === 'web';
    },
};
